import { Component, OnInit, inject } from '@angular/core';
import { LogWienConditionsOfUseService, NavigationStateService } from '@mwe/services';
import { Router } from '@angular/router';
import { LoadingSpinnerExtendedComponent } from '@mwe/ui/components';

@Component({
  selector: 'mwe-gateway-auth',
  templateUrl: './gateway-auth.component.html',
  imports: [LoadingSpinnerExtendedComponent],
})
export class GatewayAuthComponent implements OnInit {
  private router = inject(Router);
  private logwienConditionsOfUseService = inject(LogWienConditionsOfUseService);
  private navigationStateService = inject(NavigationStateService);

  async ngOnInit() {
    // check user migration approval
    const route = await this.logwienConditionsOfUseService.getRouteForConsentStatus();
    if (route) {
      await this.router.navigateByUrl(route);
    } else {
      // check deep linking
      this.navigationStateService.navigateInitialUrl();
    }
  }
}
